import React from 'react';
import { allowedUnorderedListProps } from './_allowedPropTypes';

const UnorderedList = React.forwardRef((props, ref) => {
  const {
    title,
    ariaLive = 'assertive',
    ariaAtomic = false,
    ariaRelevant = ['additions', 'removals'],
    htmlAttributes = {},
    children
  } = props;

  return (
    <ul
      {...htmlAttributes}
      ref={ref}
      title={title}
      aria-live={ariaLive}
      aria-relevant={ariaRelevant.join(' ')}
      aria-atomic={ariaAtomic}
    >
      {children}
    </ul>
  );
});

UnorderedList.propTypes = allowedUnorderedListProps;

export default UnorderedList;